module.exports = __webpack_public_path__ + "static/media/bei1.99fef748.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bei1.png
// module id = 393
// module chunks = 0